import { recordsApi } from "shared/api/recordsApi";

export const recordGetRequest = (payload) => {
  return recordsApi.getRecord(payload);
};
